import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { postRequest, getNewRequest } from '../../Utils/AppApi';
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { Divider, Tooltip, Modal, Tabs, Card, Form, Input, Button, Typography, Row, Col, Spin } from 'antd';
import { BBPS_COMPLAINT_SUBMIT, BBPS_COMPLAINT_HISTORY } from '../../Utils/appConstants';
import moment from 'moment';

const { Title, Text } = Typography;
const { TabPane } = Tabs;

function Complaint() {
  const history = useHistory();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState(1);
  const [modalVisible, setModalVisible] = useState(false);
  const [submittedComplaintId, setSubmittedComplaintId] = useState('');

  const limit = 10;

  const fetchHistory = async () => {
    setLoading(true);
    try {
      const response = await getNewRequest(`${BBPS_COMPLAINT_HISTORY}?page=${page}&limit=${limit}`, history);
      if (response.success) {
        setHistoryData(response.data.docs);
        setTotalRecords(response.data.totalDocs);
      } else {
        toast.error(response.message || 'Failed to load history');
      }
    } catch (err) {
      toast.error('Error fetching complaint history');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, [page]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await postRequest(BBPS_COMPLAINT_SUBMIT, values, history);
      if (response.success) {
        toast.success(response.message);
        setSubmittedComplaintId(response.data.complaintId);
        setModalVisible(true);
        form.resetFields();
        fetchHistory(); // refresh history
      } else {
        toast.error(response.message || 'Failed to submit complaint');
        if (response.data?.complaintId) {
          setSubmittedComplaintId(response.data.complaintId);
          setModalVisible(true);
        }
      }
    } catch (err) {
      toast.error('Error submitting complaint');
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { name: 'Complaint ID', selector: row => row.complaintId, width: '200px' },
    { name: 'Order ID', selector: row => row.orderId, width: '200px' },
    { name: 'Description', selector: row => row.description, width: '300px' },
    {
      name: 'Date',
      selector: row => moment(row.date).format('DD-MM-YYYY HH:mm'),
      width: '160px'
    },
    {
      name: 'Status',
      cell: row => (
        <span style={{ color: row.status === 'Resolved' ? 'green' : (row.status === 'Pending' ? 'orange' : 'red'), fontWeight: 'bold' }}>
          {row.status}
        </span>
      ),
      width: '120px'
    }
  ];

  return (
    <div style={{ backgroundColor: '#f0f2f5', minHeight: '100vh', padding: '20px' }}>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card style={{ borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
            <Tabs defaultActiveKey="new">
              <TabPane tab={<span style={{ fontWeight: 'bold', color: '#1890ff' }}>New Complaint</span>} key="new">
                <Card title={<Title level={4}>Submit a Complaint</Title>} style={{ borderRadius: '8px', marginTop: '16px' }}>
                  <Form form={form} layout="vertical" onFinish={handleSubmit} style={{ maxWidth: 600 }}>
                    <Form.Item
                      label="Order ID"
                      name="orderid"
                      rules={[{ required: true, message: 'Order ID is required' }]}
                    >
                      <Input placeholder="Enter the transaction order ID" size="large" />
                    </Form.Item>
                    <Form.Item
                      label="Remark / Description"
                      name="remark"
                      rules={[{ required: true, message: 'Please describe your issue' }]}
                    >
                      <Input.TextArea rows={4} placeholder="Explain the problem in detail" size="large" />
                    </Form.Item>
                    <Form.Item>
                      <Button type="primary" htmlType="submit" loading={loading} size="large" shape="round" block>
                        Submit Complaint
                      </Button>
                    </Form.Item>
                  </Form>
                </Card>
              </TabPane>

              <TabPane tab={<span style={{ fontWeight: 'bold', color: '#fa8c16' }}>Complaint History</span>} key="history">
                <Card title={<Title level={4}>Your Complaints</Title>} style={{ borderRadius: '8px', marginTop: '16px' }}>
                  <DataTable
                    columns={columns}
                    data={historyData}
                    progressPending={loading}
                    pagination
                    paginationServer
                    paginationTotalRows={totalRecords}
                    onChangePage={(newPage) => setPage(newPage)}
                    onChangeRowsPerPage={(newLimit, newPage) => { setPage(newPage); fetchHistory(); }}
                    highlightOnHover
                  />
                </Card>
              </TabPane>
            </Tabs>
          </Card>
        </Col>
      </Row>

      <Modal
        title="Complaint Submitted"
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={[
          <Button key="ok" type="primary" onClick={() => setModalVisible(false)}>
            OK
          </Button>
        ]}
      >
        <p>Your complaint has been recorded.</p>
        <p><strong>Complaint ID:</strong> {submittedComplaintId}</p>
        <p>We will process it shortly. You can track its status in the "Complaint History" tab.</p>
      </Modal>

      <ToastContainer position="top-center" autoClose={5000} limit={2} theme="colored" />
    </div>
  );
}

export default Complaint;